import {AfterViewChecked, AfterViewInit, Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {SetService} from "./set.service";
import {NotifierService} from "../notifier/notifier.service";
import {NotificationType} from "../notifier/notification-type.enum";
import {SetsPagerService} from "./pager.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {forkJoin} from "rxjs/observable/forkJoin";
import {Set} from "../../model/set";
import {CreateSetStep} from "./create-set-step.enum";
import {Report} from "../../model/report";
import {CommonService} from "../../common/common.service";
import {HeaderService} from "../header/header.service";
import {BreadcumbsService} from "../breadcumbs/breadcumbs.service";
import {ActivatedRoute} from "@angular/router";
import {Group} from "../../model/group";

@Component({
  selector: 'pbc-sets',
  templateUrl: './sets.component.html',
})
export class SetsComponent implements OnInit, AfterViewChecked {


  @ViewChild('setName') setNameField : ElementRef;
  ngAfterViewChecked(): void {
    if (this.setNameField)
      this.setNameField.nativeElement.focus();
  }

  private sets: Array<Set> = [];
  setsSelected: Array<number> = [];
  allSetsMarked: boolean = false;
  private idSetForEdit: string = '';
  private setNameForDisplayOnForms: string = '';
  private filteredSetsCounter : number = this.sets.length;

  private readonly MORE_LESS_LIMIT : number = 6;

  //Sortowania
  orderByField : string = "name";
  orderAsc : boolean =  true;
  setsAreFiltered : boolean = false;

  private showSetsToAssignReportsFromSection : boolean = false;
  private setsToAssignReportsFromSelected : Array<number> = [];
  setsToAssignReportsFromMoreLess : Array<Set> = [];
  private setsToAssignReportsFromVisibility : boolean = false;
  private reportsToAssignToSets : Array<Report> = [];
  private reportsToAssignToSetSelected : Array<number> = [];

  private contentTypes: Array<any>;
  private contentTypesSelected: Array<any> = [];
  private contentTypesSelectedForFilter: Array<any> = [];

  private products: Array<any>;
  private productsSelected: Array<any> = [];
  private productsSelectedForFilter: Array<any> = [];
  private productsVisibility: boolean = false;

  private reports: Array<any> = [];
  private reportsShowHide: Array<any> = [];

  private institutions: Array<any>;
  private institutionsSelected: Array<any> = [];
  private institutionsSelectedForFilter: Array<any> = [];
  private institutionsVisibility: boolean = false;

  userGroups : Array<Group> = [];
  userGroupsSelectedForFilter : Array<number> = [];
  private clientGroups: Array<any>;
  private clientGroupsSelected: Array<any> = [];
  private clientGroupsSelectedForFilter: Array<any> = [];
  private clientGroupsVisibility: boolean = false;

  private interestAreas: Array<any>;
  private interestAreasSelected: Array<any> = [];
  private interestAreasSelectedForFilter: Array<any> = [];
  private interestAreasVisibility: boolean = false;

  private publicationFrequencies: Array<any>;
  private publicationFrequenciesSelected: Array<any> = [];
  private publicationFrequenciesSelectedForFilter: Array<any> = [];
  private publicationFrequenciesVisibility: boolean = false;
  setsToAssignReportsFrom : Array<Set> = [];

  pager: any = new Object();
  pagedSets: Array<any>;
  private static pageSize: number = 20;
  private currentPage : number = 1;

  showCreateAndEditSetPopupForm: boolean = false;
  showConfirmRemoveSetPopup: boolean = false;
  showRemoveReportsFromSetPopup: boolean = false;
  showFilterPopup: boolean = false;

  private static readonly createSetTitle: string = "Nowy zestaw raportów";
  private static readonly updateSetTitle: string = "Edytuj zestaw";
  private static readonly createButtonLabel: string = "Dodaj zestaw";
  private static readonly updateButtonLabel: string = "Zapisz zmiany";

  private createFormSetup: boolean = true;
  private createEditSetForm: FormGroup;
  private createEditSetFormTitle: string = SetsComponent.createSetTitle;
  private createEditSetButtonLabel: string = SetsComponent.createButtonLabel;

  currentCreateStep : CreateSetStep = null;
  createSetStepEnum = CreateSetStep;

  constructor(
    private setService: SetService,
    private notifierService: NotifierService,
    private pagerService: SetsPagerService,
    private headerService : HeaderService,
    private commonService : CommonService,
    private breadCrumbsService : BreadcumbsService,
    private activatedRoute : ActivatedRoute
  ) {
    this.createEditSetForm = new FormGroup({
      'setName': new FormControl('', [Validators.required])
    });
  }

  ngOnInit() {
    setTimeout(()=>this.breadCrumbsService.setSubfolder.emit("Zestawy"),100);

    this.activatedRoute.params.subscribe(
      queryParams => {
        const refresh = queryParams['refresh'];
        if (refresh > 0)
          this.resetFilterSetForm();
      }
    )

    this.headerService.hideLoginRegisterButtons();
    this.getDictionaries();
    this.getSets();
  }

  private modifySetsToAssignReportFromVisibility(){
    this.setsToAssignReportsFromVisibility = !this.setsToAssignReportsFromVisibility;
    if (!this.setsToAssignReportsFromVisibility) {
      this.setsToAssignReportsFromSelected = [];
    }
  }

  /**
   * W zaleźności od  wartości parametru select dodaje/usuwa wszystkie zestawy do/z tablicy wybranych zestawów
   * @param select
   */
  selectAllSets(): void {

    this.allSetsMarked = !this.allSetsMarked;

    for (let set of this.sets) {
      let setPosition = this.setsSelected.indexOf(set.id);

      if (this.allSetsMarked && setPosition === -1)
        this.setsSelected.push(set.id);

      if (!this.allSetsMarked && setPosition !== -1)
        this.setsSelected.splice(setPosition, 1);
    }
  }

  private showConfirmForReportRemove(reportId: string) {
    let reportPosition = this.reportsShowHide.indexOf(reportId);
    if (reportPosition == -1)
      this.reportsShowHide.push(reportId);
    else
      this.reportsShowHide.splice(reportPosition, 1);
  }

  private changeProductsVisibility() {
    this.productsVisibility = !this.productsVisibility;
  }

  private modifyProductsSelected(productId: string) {
    if (this.productsSelected.indexOf(productId) === -1) {
      this.productsSelected.push(productId);
    } else {
      this.productsSelected.splice(this.productsSelected.indexOf(productId), 1);
    }
  }

  private modifyProductsSelectedForFilter(productId: string) {
    let position = this.productsSelectedForFilter.indexOf(productId);
    if (position == -1)
      this.productsSelectedForFilter.push(productId)
    else
      this.productsSelectedForFilter.splice(position, 1);

    this.getFilteredSets(false);
  }

  private changeInstitutionsVisibility(): void {
    this.institutionsVisibility = !this.institutionsVisibility;
  }

  private modifyInstitutionsSelected(institutionId: string): void {
    let idPosition = this.institutionsSelected.indexOf(institutionId);
    if (idPosition === -1) {
      this.institutionsSelected.push(institutionId);
    } else {
      this.institutionsSelected.splice(idPosition, 1);
    }
  }

  private modifyInstitutionsSelectedForFilter(institutionId: string): void {
    let position = this.institutionsSelectedForFilter.indexOf(institutionId);
    if (position === -1)
      this.institutionsSelectedForFilter.push(institutionId);
    else
      this.institutionsSelectedForFilter.splice(position, 1);

    this.getFilteredSets(false);
  }

  private changeClientGroupsVisibility() {
    this.clientGroupsVisibility = !this.clientGroupsVisibility;
  }

  private modifyClientGroupsSelected(clientGroupId: string) {
    let idPosition = this.clientGroupsSelected.indexOf(clientGroupId);
    if (idPosition === -1) {
      this.clientGroupsSelected.push(clientGroupId);
    } else {
      this.clientGroupsSelected.splice(idPosition, 1);
    }
  }

  private modifyClientGroupsSelectedForFilter(clientGroupId: string) {
    let position = this.clientGroupsSelectedForFilter.indexOf(clientGroupId);

    if (position === -1)
      this.clientGroupsSelectedForFilter.push(clientGroupId);
    else
      this.clientGroupsSelectedForFilter.splice(position, 1);

    this.getFilteredSets(false);
  }

  private changeInterestAreasVisibility() {
    this.interestAreasVisibility = !this.interestAreasVisibility;
  }

  private modifyInterestAreasSelected(interestAreaId: string) {
    let idPosition = this.interestAreasSelected.indexOf(interestAreaId);
    if (idPosition === -1) {
      this.interestAreasSelected.push(interestAreaId);
    } else {
      this.interestAreasSelected.splice(idPosition, 1);
    }
  }

  private modifyInterestAreaSelectedForFilter(interestAreaId: string) {
    let position = this.interestAreasSelectedForFilter.indexOf(interestAreaId);
    if (position === -1)
      this.interestAreasSelectedForFilter.push(interestAreaId);
    else
      this.interestAreasSelectedForFilter.splice(position, 1);

    this.getFilteredSets(false);
  }

  private changePublicationFreqenciesVisibility(): void {
    this.publicationFrequenciesVisibility = !this.publicationFrequenciesVisibility;
  }

  private modifySetsSelected(setId: number): void {
    let idPosition = this.setsSelected.indexOf(setId);

    if (idPosition === -1) {
      this.setsSelected.push(setId);
    } else {
      this.setsSelected.splice(idPosition, 1);
    }

    if (this.setsSelected.length === this.sets.length)
      this.allSetsMarked = true;
    else
      this.allSetsMarked = false;
  }

  /**
   *
   * @param list - lista na której są i/lub będą dodawane lub usuwane wybrane przez użytkownika pozycje
   * @param id - id danej pozycji
   */
  private modifySelectedOptionList(list: Array<string>, id: string) : void {
    let idPosition = list.indexOf(id);
    if (idPosition == -1)
      list.push(id);
    else
      list.splice(idPosition,1);
  }

  private resetCreateUpdateSetForm(): void {
    this.contentTypesSelected = [];
    this.productsSelected = [];
    this.productsVisibility = false;
    this.institutionsSelected = [];
    this.institutionsVisibility = false;
    this.clientGroupsSelected = [];
    this.clientGroupsVisibility = false;
    this.publicationFrequenciesSelected = [];
    this.publicationFrequenciesVisibility = false;
    this.interestAreasSelected = [];
    this.interestAreasVisibility = false;
    this.setsToAssignReportsFromVisibility = false;
    this.setsToAssignReportsFromSelected = [];
    this.createEditSetForm.controls['setName'].reset();
  }

  private resetFilterSetForm(): void {
    this.contentTypesSelectedForFilter = [];
    this.productsSelectedForFilter = [];
    this.clientGroupsSelectedForFilter = [];
    this.institutionsSelectedForFilter = [];
    this.interestAreasSelectedForFilter = [];
    this.publicationFrequenciesSelectedForFilter = [];
    this.interestAreasSelectedForFilter = [];
    this.userGroupsSelectedForFilter = [];

    this.setsAreFiltered = false;
    this.closeFilter();

    this.getFilteredSets(true);
  }

  private modifyPublicationFreqenciesSelected(frequencyId: string): void {
    let idPosition = this.publicationFrequenciesSelected.indexOf(frequencyId);
    if (idPosition === -1) {
      this.publicationFrequenciesSelected.push(frequencyId);
    } else {
      this.publicationFrequenciesSelected.splice(idPosition, 1);
    }
  }

  private modifyPublicationFrequenciesSelectedForFilter(frequencyId : string) : void {
    let position = this.publicationFrequenciesSelectedForFilter.indexOf(frequencyId);
    if (position === -1)
      this.publicationFrequenciesSelectedForFilter.push(frequencyId);
    else
      this.publicationFrequenciesSelectedForFilter.splice(position, 1);

    this.getFilteredSets(false);
  }

  private modifyContentTypesSelectedForFilter(contentTypeId : string) {
    let position = this.contentTypesSelectedForFilter.indexOf(contentTypeId);
    if (position == -1)
      this.contentTypesSelectedForFilter.push(contentTypeId);
    else
      this.contentTypesSelectedForFilter.splice(position, 1);

    this.getFilteredSets(false);
  }

  modifyUserGroupForFilterSelected(userGroupId: number) {
    let position = this.userGroupsSelectedForFilter.indexOf(userGroupId);
    if (position === -1)
      this.userGroupsSelectedForFilter.push(userGroupId);
    else
      this.userGroupsSelectedForFilter.splice(position, 1);

    this.getFilteredSets(false);
  }

  private contentTypeChanged(event: any): void {
    if (event.target.checked) {
      if (this.contentTypesSelected.indexOf(event.target.value) === -1) {
        this.contentTypesSelected.push(event.target.value);
      }
    } else {
      this.contentTypesSelected.splice(this.contentTypesSelected.indexOf(event.target.value), 1);
    }
  }

  private getDictionaries() {
    forkJoin(
      this.setService.getDictContentType(),
      this.setService.getDictProduct(),
      this.commonService.getInstitutionDictionary(),
      this.setService.getClientGroups(),
      this.setService.getInterestArea(),
      this.setService.getPublicationFreqency(),
      this.setService.getSetList("name ASC"),
      this.commonService.getGroupList("name ASC")
    ).subscribe(([contentType, products, institution, clientGroups, interestArea, publicationFrequency, setsToAssignReportsFrom, userGroups]) => {
        this.contentTypes = contentType;
        this.products = products;
        this.institutions = institution;
        this.clientGroups = clientGroups;
        this.interestAreas = interestArea;
        this.publicationFrequencies = publicationFrequency;
        this.setsToAssignReportsFrom = setsToAssignReportsFrom['record'];
        this.userGroups = userGroups.record;
      },
      (error) => {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Pojawił się błąd przy pobieraniu słowników");
        console.log("Błąd przy pobieraniu słowników:", JSON.stringify(error));
      });
  }

  private setsToAssignReportsFromMoreLessClick() {
    if (this.setsToAssignReportsFromMoreLess.length < this.setsToAssignReportsFrom.length) {
      this.setsToAssignReportsFromMoreLess = this.setsToAssignReportsFrom.slice();
    } else {
      this.setsToAssignReportsFromMoreLess = this.setsToAssignReportsFrom.slice(0, this.MORE_LESS_LIMIT-1);
    }
  }


  showCreateEditSetForm(create: boolean, setid?: string): void {
    this.createFormSetup = create;
    this.resetCreateUpdateSetForm();

    if (this.setsToAssignReportsFrom.length > this.MORE_LESS_LIMIT) {
      this.setsToAssignReportsFromMoreLess = this.setsToAssignReportsFrom.slice(0, this.MORE_LESS_LIMIT-1)
    } else {
      this.setsToAssignReportsFromMoreLess = this.setsToAssignReportsFrom;
    }

    this.currentCreateStep = CreateSetStep.Definition;

    if (create) {
      this.createEditSetFormTitle = SetsComponent.createSetTitle;
      this.createEditSetButtonLabel = SetsComponent.createButtonLabel;
      this.showCreateAndEditSetPopupForm = true;
      this.idSetForEdit = "";
      this.showSetsToAssignReportsFromSection = true;
    } else {
      this.createEditSetFormTitle = SetsComponent.updateSetTitle;
      this.createEditSetButtonLabel = SetsComponent.updateButtonLabel;
      this.showSetsToAssignReportsFromSection = false;
      this.idSetForEdit = setid;

      this.setService.getSet(setid).subscribe(
        data => {
          let status = data['status'];
          if (status != 1) {
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie pobrano danych zestawu");
            this.showCreateAndEditSetPopupForm = false;
          } else {
            let set = data['record'][0];

            this.showCreateAndEditSetPopupForm = true;
            for (let contentType of set.contentTypes)
              this.contentTypesSelected.push(contentType.id);
            for (let product of set.thematics_products)
              this.productsSelected.push(product.id);
            for (let institution of set.thematics_institution)
              this.institutionsSelected.push(institution.id);
            for (let clientGroup of set.thematics_client_groups)
              this.clientGroupsSelected.push(clientGroup.id);
            for (let interestArea of set.thematics_area)
              this.interestAreasSelected.push(interestArea.id);
            for (let publicationFrequency of set.thematics_frequency)
              this.publicationFrequenciesSelected.push(publicationFrequency.id);

            this.createEditSetForm.controls['setName'].setValue(set.name);
          }
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie pobierania danych zestawu");
        });
    }
  }

  private closeCreateEditSetForm() {
    this.currentCreateStep = null;
  }

  showConfirmRemoveSet() {
    this.showConfirmRemoveSetPopup = true;
  }

  private closeConfirmRemoveSet() {
    this.showConfirmRemoveSetPopup = false;
  }

  showFilter(): void {
    this.showFilterPopup = true;
  }

  private closeFilter() : void {
    this.showFilterPopup = false;
  }

  private showRemoveReportsFromSet(setId: string): void {

    this.setService.getSet(setId).subscribe(
      data => {
        let status = data['status'];
        if (status != 1) {
          this.reports = [];
          this.idSetForEdit = '';
          this.showRemoveReportsFromSetPopup = false;
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: nie pobrano danych zestawu");
          this.setNameForDisplayOnForms = '';
        } else {
          this.idSetForEdit = setId;
          this.setNameForDisplayOnForms = data['record'][0]['name'];
          this.reports = data['record'][0]['reports'];
          this.showRemoveReportsFromSetPopup = true;
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania danych zastawu');
      }
    );

  }

  private closeRemoveReportsFromSet(): void {
    this.reportsShowHide = [];
    this.showRemoveReportsFromSetPopup = false;
  }

  private showFilteredSets() : void {
    this.setsAreFiltered = true;
    this.getFilteredSets(true);
    this.setsSelected = [];
    this.allSetsMarked = false;
    this.closeFilter();
  }

  private getFilteredSets(returnResult : boolean, goOnPage? : number) : void {
    let filterSettings = {};

    if (this.contentTypesSelectedForFilter.length > 0)
      filterSettings['contentTypes'] = this.contentTypesSelectedForFilter;

    if (this.productsSelectedForFilter.length > 0)
      filterSettings['thematics_products'] = this.productsSelectedForFilter;

    if (this.institutionsSelectedForFilter.length > 0)
      filterSettings['thematics_institution'] = this.institutionsSelectedForFilter;

    if (this.clientGroupsSelectedForFilter.length > 0)
      filterSettings['thematics_client_groups'] = this.clientGroupsSelectedForFilter;

    if (this.interestAreasSelectedForFilter.length > 0)
      filterSettings['thematics_area'] = this.interestAreasSelectedForFilter;

    if (this.publicationFrequenciesSelectedForFilter.length > 0)
      filterSettings['thematics_frequency'] = this.publicationFrequenciesSelectedForFilter;

    if (this.userGroupsSelectedForFilter.length > 0)
      filterSettings['groups'] = this.userGroupsSelectedForFilter;

    filterSettings['sortString'] = this.createSortString();

    this.setService.getFilteredSetList(filterSettings).subscribe(
      data => {
        let status = data['status'];
        if (status != 1) {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd: Nie pobrano listy zestawów');
        }  else {
          this.filteredSetsCounter = data['record'].length;
          if (returnResult) {
            this.sets = data['record'];
            if (goOnPage > 0)
              this.setPage(goOnPage);
            else
              this.setPage(1)
          }
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, 'Błąd w trakcie pobierania listy zestawów');
      }
    )
  }

  private getSets(goOnPage? : number) {
    this.setService.getSetList(this.createSortString()).subscribe(
      data => {
        let status = data["status"];
        if (status != 1) {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd: Nie pobrano listy zestawów");
        } else {
          this.sets = data["record"];
          this.filteredSetsCounter = this.sets.length;
          if (goOnPage > 0)
            this.setPage(goOnPage);
          else
            this.setPage(1);
        }
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Błąd w trakcie pobierania zestawów");
      }
    );
  }

  setPage(page: number) {
    this.currentPage = page;
    this.pager = this.pagerService.getPager(this.sets.length, page, SetsComponent.pageSize);
    this.pagedSets = this.sets.slice(
      this.pager.startIndex,
      this.pager.endIndex + 1
    )
  }

  private deleteSets(): void {
    let setsToRemoveParameters = {};
    setsToRemoveParameters[''] = this.setsSelected;

    this.setService.deleteSets(this.setsSelected).subscribe(
      response => {
        if (response.status === 1) {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Zestawy (".concat(this.setsSelected.length.toString(), ") raportów zostały usunięte"));
          this.setsSelected = [];
          if (this.setsAreFiltered)
            this.getFilteredSets(true, this.currentPage);
          else
            this.getSets(this.currentPage);
        } else {
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            "Wystąpił błąd. Zestawy(".concat(this.setsSelected.length.toString(),") raportów nie zostały usunięte. Spróbuj jeszcze raz"));
        }
      },
      error => {
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          "Wystąpił błąd. Zestawy(".concat(this.setsSelected.length.toString(),") raportów nie zostały usunięte. Spróbuj jeszcze raz"));
        this.setsSelected = [];
      }
    );

    this.closeConfirmRemoveSet();
  }

  private removeReportFromSet(reportId: string) {
    let setParameters = {};
    let reportPosition: number = -1;
    let reportName : string ='';

    let i = 0;
    for (let report of this.reports) {
      if (report.id === reportId) {
        reportPosition = i;
        reportName = report.title;
      }
      i++;
    }

    this.reports.splice(reportPosition, 1);
    setParameters['reports'] = this.reports;
    setParameters['id'] = this.idSetForEdit;

    this.setService.updateSet(setParameters).subscribe(
      response => {
        if (response.status == 1) {
          this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
            "Raport ".concat(reportName, " został usunięty z zestawu ", this.setNameForDisplayOnForms));
          if (this.setsAreFiltered)
            this.getFilteredSets(true, this.currentPage);
          else
            this.getSets(this.currentPage);
        }
        else
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
            'Wystąpił błąd! Raport '.concat(reportName, " nie został usunięty z zestawu ", this.setNameForDisplayOnForms));
      },
      error => {
        console.log(error);
        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
          'Wystąpił błąd! Raport '.concat(reportName, " nie został usunięty z zestawu ", this.setNameForDisplayOnForms));
      }
    )
  }

  private createUpdateSet(): void {
    let setParameters = {};

    let setName: string = this.createEditSetForm.controls['setName'].value;
    setParameters['name'] = setName;

    if (this.idSetForEdit)
      setParameters['id'] = this.idSetForEdit;

    if (this.contentTypesSelected.length > 0)
      setParameters['contentTypes'] = this.contentTypesSelected;

    if (this.productsSelected.length > 0)
      setParameters['thematics_products'] = this.productsSelected;

    if (this.institutionsSelected.length > 0)
      setParameters['thematics_institution'] = this.institutionsSelected;

    if (this.clientGroupsSelected.length > 0)
      setParameters['thematics_client_groups'] = this.clientGroupsSelected;

    if (this.interestAreasSelected.length > 0)
      setParameters['thematics_area'] = this.interestAreasSelected;

    if (this.publicationFrequenciesSelected.length > 0)
      setParameters['thematics_frequency'] = this.publicationFrequenciesSelected;

    if (this.reportsToAssignToSetSelected.length > 0)
      setParameters['reports'] = this.reportsToAssignToSetSelected;

    this.commonService.setExists(setName, this.idSetForEdit).subscribe(
        response=>{
          if (response.status != 1)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd! Nie można sprawdzić, czy zestaw o podanej nazwie istnieje");
          else
            if (response.message)
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                  "Zestaw z daną nazwą już istnieje w serwisie");
            else {
              if (this.createFormSetup) {
                this.setService.createSet(setParameters).subscribe(
                    response => {
                      if (response.status == '1') {
                        this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                            "Zestaw " + setName + " raportów został poprawnie dodany.");
                        if (this.setsAreFiltered)
                          this.getFilteredSets(true, this.currentPage);
                        else
                          this.getSets(this.currentPage);
                      } else {
                        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                            "Wystąpił błąd! Zestaw " + setName + " raportów nie został dodany. Spróbuj jeszcze raz.");
                        console.log(response);
                      }
                    },
                    error => {
                      this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                          "Wystąpił błąd! Zestaw " + setName + " raportów nie został dodany. Spróbuj jeszcze raz.");
                      console.log(error);
                    }
                );
              } else {
                this.setService.updateSet(setParameters).subscribe(
                    response => {
                      if (response.status == 1) {
                        this.notifierService.notify(NotificationType.SUCCESS_NOTIFICATION,
                            "Informacje o zestawie " + setName + " zostały zmienione");
                        if (this.setsAreFiltered)
                          this.getFilteredSets(true, this.currentPage);
                        else
                          this.getSets(this.currentPage);
                      } else {
                        this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                            "Wystąpił błąd! Informacje o zestawie " + setName + " nie zostały zmienione. Spróbuj jeszcze raz.");
                      }
                    },
                    error => {
                      console.log(error);
                      this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                          "Wystąpił błąd! Informacje o zestawie " + setName + " nie zostały zmienione. Spróbuj jeszcze raz.");
                    }
                )
              }

              this.showCreateAndEditSetPopupForm = false;
              this.currentCreateStep = null;
            }
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Nie można sprawdzić, czy zestaw o podanej nazwie istnieje");
        }
    );
  }

  private createSetNextStep() : void {
    let setName = this.createEditSetForm.controls['setName'].value;
    this.commonService.setExists(setName).subscribe(
        response => {
          if (response.status != 1)
            this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                "Wystąpił błąd! Nie można sprawdzić, czy zestaw o podanej nazwie istnieje");
          else
            if (response.message)
              this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
                  "Zestaw z daną nazwą już istnieje w serwisie");
            else {
              this.reportsToAssignToSetSelected = [];
              this.setService.getReportsBySetIds(this.setsToAssignReportsFromSelected).subscribe(
                  response =>{
                    if (response.status !=='OK')
                      this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Problem z pobraniem listy raportów dla wskazanych zestawów")
                    else {
                      this.setNameForDisplayOnForms = this.createEditSetForm.controls['setName'].value;
                      this.reportsToAssignToSets = response.record;
                      this.reportsToAssignToSets.forEach((report : Report) => {
                        this.reportsToAssignToSetSelected.push(report.id);
                      });
                      this.currentCreateStep = CreateSetStep.ReportsFromSets;
                    }
                  },
                  error => {
                    console.log(error);
                    this.notifierService.notify(NotificationType.ERROR_NOTIFICATION, "Problem z pobraniem listy raportów dla wskazanych zestawów");
                  }
              )
            }
        },
        error => {
          console.log(error);
          this.notifierService.notify(NotificationType.ERROR_NOTIFICATION,
              "Wystąpił błąd! Nie można sprawdzić, czy zestaw o podanej nazwie istnieje");
        }
    );
  }

  private modifyReportsToAssitnToSetSelected(id : number) : void {
    let position : number = this.reportsToAssignToSetSelected.indexOf(id);
    if (position === -1)
      this.reportsToAssignToSetSelected.push(id);
    else
      this.reportsToAssignToSetSelected.splice(position, 1);
  }

  private createSetPreviousStep() : void {
    this.currentCreateStep = CreateSetStep.Definition;
  }

  orderByClick(orderByField : string) {
    if (orderByField === this.orderByField)
      this.orderAsc = !this.orderAsc;
    else {
      this.orderAsc = true;
      this.orderByField = orderByField;
    }

    if (!this.setsAreFiltered)
      this.getSets(this.currentPage);
    else
      this.getFilteredSets(true, this.currentPage);
  }

  private createSortString() : string {
    let sortString = '';
    if (this.orderAsc)
      sortString = this.orderByField.concat(" ASC");
    else
      sortString = this.orderByField.concat(" DESC");

    return sortString;
  }

}
